<template>
    <v-layout row wrap align-start class="header" v-if="appLoaded">
        <v-img
                :src="appLogo"
                contain
                :title="appTitle"
                height="50"
                class="logo"
                v-on:click="goTo"
        ></v-img>
    </v-layout>
</template>

<script>
    import Router from '../router';

    export default {
        name: "Header",
        computed: {
            appLoaded() {
                return this.$store.state.application.loaded;
            },
            appTitle() {
                if (this.$store.state.application.title) {
                    return this.$store.state.application.title;
                }
                return 'Tuš'
            },
            appLogo() {
                if (this.$store.state.application.logo) {
                    return this.$store.state.application.logo;
                }
                return require('../assets/tusCC-logo.gif');
            }
        },
        methods: {
            goTo() {
                window.location.replace('/');
            }
        }
    }
</script>

<style scoped>
    .header {
        padding-top: 20px;
        padding-bottom: 40px;

    }

    .header .logo {
        cursor: pointer;
    }

    @media only screen and (max-width: 600px) {
        .header {
            padding-top: 10px;
            padding-bottom: 10px;
        }
    }

    @media only screen and (max-height: 800px) {
        .header {
            padding-top: 10px;
            padding-bottom: 10px;
        }
    }


</style>